import React, { useEffect } from "react";
import PublicLayout, { H1, Lead, SectionCta } from "../../components/PublicLayout";
import { SITE } from "../../content/site";
import { routePath, SITE_URL } from "../../lib/routes";
import { ORG_ID } from "../../components/Seo";
import { track, EVENTS } from "../../lib/analytics";

export default function About({ lang }) {
  const c = SITE[lang].about;
  useEffect(() => { window.scrollTo(0, 0); }, [lang]);
  const ld = [{
    "@context": "https://schema.org", "@type": "AboutPage",
    name: c.h1, url: `${SITE_URL}${routePath("about", lang)}`, inLanguage: lang,
    mainEntity: { "@id": ORG_ID },
  }];
  return (
    <PublicLayout pageKey="about" lang={lang} jsonLd={ld}
      crumbs={[{ name: SITE[lang].breadcrumbs.about, path: routePath("about", lang) }]}>
      <div className="mx-auto max-w-[900px] px-6 py-14 md:px-8 md:py-20" data-testid="about-page">
        <H1>{c.h1}</H1>
        <Lead>{c.lead}</Lead>
        <div className="mt-10 space-y-5">
          {c.paragraphs.map((p, i) => (
            <p key={i} className="text-base font-light leading-relaxed text-[#2a2b29]">{p}</p>
          ))}
        </div>
        <div className="mt-14 grid gap-8 border-t border-black/8 pt-10 sm:grid-cols-2">
          <section data-testid="about-founder">
            <h2 className="text-[11px] font-semibold uppercase tracking-[0.18em] text-[#9a9d98]">{c.founderTitle}</h2>
            <p className="mt-3 text-base font-medium text-[#050505]">{c.founder.name}</p>
            <p className="text-sm font-light text-[#6b6f6c]">{c.founder.role}</p>
          </section>
          <section data-testid="about-legal">
            <h2 className="text-[11px] font-semibold uppercase tracking-[0.18em] text-[#9a9d98]">{c.legalTitle}</h2>
            <address className="mt-3 text-sm font-light not-italic leading-relaxed text-[#6b6f6c]">
              {c.legal.map((l, i) => <span key={i} className="block">{l}</span>)}
            </address>
          </section>
        </div>
        <SectionCta title={c.cta.title} text={c.cta.text} lang={lang}
          onClick={() => track(EVENTS.CTA_CLICK, { cta: "about_contact" })} />
      </div>
    </PublicLayout>
  );
}
